<div class="alert alert-dismissable" role="alert" *ngFor="let alert of alerts" style="white-space: pre-wrap;">
  <i class="icon {{cssClass(alert)}}"></i>
  {{alert.message | translate}}
  <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" (click)="removeAlert(alert)">
    <span aria-hidden="true" class="icon-close"></span>
  </button>
</div>
